/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Button, Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBars,
  faVolumeXmark,
  faVolumeHigh,
} from '@fortawesome/free-solid-svg-icons'
import IntroAnimation from './IntroAnimation'
import { mobilePhone, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function ImageAndVideoPreview({
  srcs,
  hasIntroAnimation,
  introAnimation,
  setHasIntroAnimation,
  redirectImage,
  redirectVideo,
}) {
  const [showIntro, setShowIntro] = useState(hasIntroAnimation)
  const imageSrc = srcs.find((s) => s.type === 'img')?.file
  const videoSrc = srcs.find((s) => s.type === 'video')?.file
  const videoRef = useRef(null)
  const [isMuted, setIsMuted] = useState(true)
  const [showMedia, setShowMedia] = useState(true)

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current
        .play()
        .catch((error) => console.error('Autoplay failed:', error))
    }
  }, [videoSrc])

  useEffect(() => {
    if (hasIntroAnimation) {
      setTimeout(() => setShowIntro(false), 3000)
    }
  }, [hasIntroAnimation])

  let videoURL = ''
  if (videoSrc instanceof File || videoSrc instanceof Blob) {
    try {
      videoURL = URL.createObjectURL(videoSrc)
    } catch (e) {
      console.warn('createObjectURL failed for videoSrc', videoSrc, e)
    }
  } else if (typeof videoSrc === 'string') {
    videoURL = videoSrc
  }

  let imageURL = ''
  if (imageSrc instanceof File || imageSrc instanceof Blob) {
    try {
      imageURL = URL.createObjectURL(imageSrc)
    } catch (e) {
      console.warn('createObjectURL failed for imageSrc', imageSrc, e)
    }
  } else if (typeof imageSrc === 'string') {
    imageURL = imageSrc
  }

  if (showIntro && introAnimation) {
    return (
      <IntroAnimation
        file={introAnimation}
        onClose={() => setHasIntroAnimation(false)}
      />
    )
  }

  if (!srcs.length || !srcs[0]?.file) {
    return (
      <div
        className="scroller-hide"
        style={{ maxHeight: '57.5vh', overflow: 'auto' }}
      >
        <div className="w-100 pb-1">
          <Image
            className="position-absolute"
            src={mobilePhone}
            style={{ width: '19.5rem', right: '16%', top: '6%' }}
          />
          <div style={{ position: 'relative' }}>
            <div
              className="border-bottom mb-3 d-flex"
              style={{ width: '240px', height: '55px', zIndex: '0' }}
            >
              <div className="w-80 m-auto ms-auto">
                <Image src={wavenet_logo} className="w-75 ps-3" />
              </div>
              <div className="w-20 m-auto ms-auto d-flex">
                <FontAwesomeIcon icon={faBars} className="text-end" />
              </div>
            </div>
            <div className="text-title" />
            <div className="text-line" />
            <div className="text-line" />
            <div className="text-ban1" />
            <div className="text-line" />
            <div className="text-line" />
            <div className="text-line2" />
            <div className="text-line" />
            <div className="text-line" />
            <div className="text-line" />
            <div className="text-line" />
            <div className="text-line" />
            <div className="text-line" />
            <br />
            <div className="text-line" />
            <div className="text-line" />
            <div className="text-line" />
          </div>
        </div>

        <div style={{ position: 'relative', paddingTop: '1rem' }}>
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
        </div>
      </div>
    )
  }

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      <div className="w-100 h-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
        <div style={{ position: 'relative' }}>
          <div className="text-title" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-ban1" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line2" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <br />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
          <div className="text-line" />
        </div>
      </div>

      {showMedia && (
        <>
          <Button
            className="media-close-btn"
            onClick={() => setShowMedia(false)}
          >
            ✕
          </Button>

          <div className="media-image-container">
            {imageSrc && (
              <>
                <Image
                  className="media-image-preview"
                  src={imageURL}
                  alt="Uploaded Image"
                  onClick={() =>
                    redirectImage && window.open(redirectImage, '_blank')
                  }
                />
                <CIIcon />
              </>
            )}

            {videoSrc && (
              <div
                role="presentation"
                className="video-wrapper media-video-wrapper"
                onClick={() =>
                  redirectVideo && window.open(redirectVideo, '_blank')
                }
              >
                <video
                  ref={videoRef}
                  autoPlay
                  muted={isMuted}
                  loop
                  className="video-player"
                >
                  <source src={videoURL} type="video/mp4" />
                  <track kind="captions" />
                </video>
                <div
                  role="presentation"
                  onClick={(e) => {
                    e.stopPropagation()
                    const newMuted = !isMuted
                    setIsMuted(newMuted)
                    if (videoRef.current) {
                      videoRef.current.muted = newMuted
                    }
                  }}
                  style={{
                    position: 'absolute',
                    left: '0px',
                    bottom: '5px',
                    zIndex: 1100,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    borderRadius: '50%',
                    width: '22px',
                    height: '22px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <FontAwesomeIcon
                    icon={isMuted ? faVolumeXmark : faVolumeHigh}
                    style={{ color: 'white', fontSize: '12px' }}
                  />
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  )
}

ImageAndVideoPreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
        PropTypes.string,
      ]),
    })
  ).isRequired,
  hasIntroAnimation: PropTypes.bool.isRequired,
  introAnimation: PropTypes.oneOfType([
    PropTypes.instanceOf(File),
    PropTypes.instanceOf(Blob),
    PropTypes.string,
  ]),
  setHasIntroAnimation: PropTypes.func.isRequired,
  redirectImage: PropTypes.string,
  redirectVideo: PropTypes.string,
}

ImageAndVideoPreview.defaultProps = {
  introAnimation: null,
  redirectImage: '',
  redirectVideo: '',
}

export default ImageAndVideoPreview
